export default {_name:'text.iconBlock',module:'Field',view:'Element/Text/IconBlock',options:{md:12}}